import { render, staticRenderFns } from "./Iik150cSerhiEklenmesiTalepEvrakForm.vue?vue&type=template&id=2ee5a1da"
import script from "./Iik150cSerhiEklenmesiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./Iik150cSerhiEklenmesiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports